import React,{useState,useEffect} from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import {userService} from '../../services/userService';
import BeltIcon from '../BeltIcon';
import {useAuth} from '../../context/AuthContext';

const {FiPlus,FiEdit2,FiUser,FiShield,FiUserX,FiUserCheck}=FiIcons;

export default function UserManagement({onEditUser,onAddUser,users: externalUsers}) {
  const [users,setUsers]=useState(externalUsers || []);
  const {user: currentUser}=useAuth();

  useEffect(()=>{
    if (!externalUsers) {
      userService.getUsers().then(setUsers).catch(error=> alert(error.message));
    } else {
      setUsers(externalUsers);
    }
  },[externalUsers]);

  const handleToggleActive=async (target)=>{
    const message=target.active
      ? `¿Desactivar a ${target.name}? Ya no podrá entrar al portal, pero se conserva su historial.`
      : `¿Reactivar a ${target.name}?`;
    if (window.confirm(message)) {
      try {
        setUsers(await userService.setActive(target.id,!target.active));
      } catch (error) {
        alert(error.message);
      }
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 pb-20">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-12">
        <div>
          <span className="text-red-500 font-black tracking-[0.4em] uppercase text-[10px] mb-4 block">
            Administración
          </span>

          <h2 className="text-5xl font-black uppercase tracking-tighter text-white">
            Usuarios del Dojang
          </h2>
        </div>

        <button
          onClick={onAddUser}
          className="bg-red-600 hover:bg-red-500 text-white px-8 py-4 rounded-2xl font-black uppercase tracking-widest text-[10px] flex items-center gap-3 transition-all shadow-xl shadow-red-600/20"
        >
          <SafeIcon icon={FiPlus} />
          Nuevo Usuario
        </button>
      </div>

      <div className="grid gap-4">
        {users.map(user=> (
          <motion.div
            layout
            key={user.id}
            className={`glass-card-light rounded-3xl p-6 flex flex-col md:flex-row items-center justify-between gap-6 hover:bg-white/10 transition-all border-white/5 ${user.active ? '' : 'opacity-60'}`}
          >
            <div className="flex items-center gap-6 flex-1">
              <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center text-white">
                <SafeIcon icon={FiUser} className="w-6 h-6 text-white" />
              </div>

              <div>
                <h3 className="font-bold text-white uppercase tracking-tight [text-shadow:_0_2px_6px_rgba(0,0,0,0.85)]">
                  {user.name}
                  {!user.active && (
                    <span className="ml-3 px-3 py-0.5 rounded-full bg-zinc-700 text-[9px] font-black tracking-widest align-middle">
                      Desactivado
                    </span>
                  )}
                </h3>

                <p className="text-white text-xs [text-shadow:_0_2px_6px_rgba(0,0,0,0.85)]">
                  {user.email}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-8 text-[10px] font-black uppercase tracking-widest text-zinc-400">
              <div className="flex items-center gap-2">
                <BeltIcon type={user.belt} className="w-10 h-3" />
              </div>

              <div className="flex items-center gap-2 text-white [text-shadow:_0_2px_6px_rgba(0,0,0,0.85)]">
                <SafeIcon icon={FiShield} className="text-white" />
                {user.roles.join(',')}
              </div>
            </div>

            <div className="flex gap-2">
              <button
                onClick={()=> onEditUser(user)}
                className="p-3 bg-white/5 hover:bg-white/10 rounded-xl text-white transition-all"
              >
                <SafeIcon icon={FiEdit2} className="w-4 h-4 text-white" />
              </button>

              <button
                onClick={()=> handleToggleActive(user)}
                title={user.active ? 'Desactivar usuario' : 'Reactivar usuario'}
                aria-label={user.active ? 'Desactivar usuario' : 'Reactivar usuario'}
                className={`p-3 bg-white/5 ${user.active ? 'hover:bg-red-600' : 'hover:bg-green-600'} rounded-xl text-white transition-all ${user.id===currentUser?.id ? 'opacity-20 pointer-events-none' : ''}`}
              >
                <SafeIcon icon={user.active ? FiUserX : FiUserCheck} className="w-4 h-4 text-white" />
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}